export default __webpack_public_path__ + "static/media/settings.f4b583fb.svg";